import React from 'react';
import debounce from 'lodash.debounce';
import queryString from 'querystring';

import api from "utils/api";
import reverseUrl from 'utils/urls';
import {gettext, interpolate, pgettext} from '../utils/text';


class Search extends React.Component {

    initialQuery = queryString.parse(window.location.search.substr(1)).q || "";  // eslint-disable-line

    state = {
        query: this.initialQuery,
        result: {},
        focus: false,
        hover: false,
    };

    componentDidMount() {
        if (this.state.query.length) {
            this.search();
        }
    }

    onChange = (e) => {
        this.setState({query: e.target.value}, this.searchDebounce);
    };

    getQuery(word) {
        const query = queryString.parse(window.location.search.substr(1));
        delete query.paginate_by;
        delete query.sort_by;
        let selectedFacets = query.selected_facets;
        // selectedFacets can be string (if there was just one of them) or array
        if (selectedFacets && typeof selectedFacets.forEach !== 'function') {
            selectedFacets = [selectedFacets];
        }
        // Remove duplicates
        if (selectedFacets) {
            selectedFacets = [...new Set(selectedFacets)];
            query.selected_facets = selectedFacets;
        }
        return {...query, q: word || this.state.query};
    }

    search = () => {
        // we could also use this.getQuery() to force the facet checks for the search queryset
        api.search.fetch(null, {q: this.state.query}).then(result => this.setState({result}));
    };

    searchDebounce = debounce(this.search, 300);

    renderFacets = () => {
        const facets = this.state.result.facets;

        const renderFacet = (facet) => {
            const facetSearchString = `active_substance_exact:${facet[0]}`;

            const query = this.getQuery();
            let selectedFacets = query.selected_facets || [];

            // we probably want to tighten the search, so we discard the other active substances
            selectedFacets = selectedFacets.filter(f => !f.includes('active_substance_exact:'));

            selectedFacets.push(facetSearchString);
            selectedFacets = [...new Set(selectedFacets)];
            query.selected_facets = selectedFacets;

            const count = facet[1];
            const productsString = interpolate(gettext('%s products'), [count]);

            const facetUrl = `${reverseUrl('catalogue:index')}?${queryString.stringify(query)}`;
            return (
                <a key={facet[0]} href={facetUrl}>
                    <li>
                        {facet[0]}
                        <span className="pull-right">{productsString}</span>
                    </li>
                </a>
            );
        };

        if (facets && facets.active_substance) {
            return facets.active_substance.filter(
                facet => facet[1],
            ).map(renderFacet);
        }
        return [];
    };

    renderSpelling = () => {
        const spellcheck = this.state.result.spellcheck;
        const words = [];
        if (spellcheck) {
            spellcheck.forEach(e => words.push(...e.suggestion));
        }

        const renderWord = (w) => {
            const query = queryString.stringify(this.getQuery(w.word));
            const spellingUrl = `${reverseUrl('catalogue:index')}?${query}`;
            return (
                <a key={w.word} href={spellingUrl}>
                    <li>{w.word}</li>
                </a>
            );
        };
        return words.map(renderWord).slice(0, 5);
    };

    renderTitle = (highlighted) => {
        const boldOrNot = ([phrase, strong], index) => {
            if (strong) {
                return <strong key={`${index}-${phrase}`}>{phrase}</strong>;
            }
            return phrase;
        };
        return highlighted.map(boldOrNot);
    };

    renderProducts = () => {
        const products = this.state.result.products;
        const renderProduct = (e) => {
            const highlighted = e.highlighted;
            if (!!highlighted && highlighted.length) {
                return (
                    <a key={e.upc} href={reverseUrl('catalogue:detail', e.slug, e.pk)}>
                        <li>
                            {this.renderTitle(highlighted)}
                        </li>
                    </a>
                );
            }
            return <li key={e.upc}>{e.title}</li>;
        };
        if (products && products.length) {
            return products.map(renderProduct);
        }
        return [];
    };

    render() {
        const spelling = this.renderSpelling();
        const products = this.renderProducts();
        const facets = this.renderFacets();

        const showDropdown = (
            this.state.focus || this.state.hover
        ) && (spelling.length || products.length || facets.length);

        const setFocus = () => this.setState({focus: true});
        const unsetFocus = () => this.setState({focus: false});
        const setHover = () => this.setState({hover: true});
        const unsetHover = () => this.setState({hover: false});

        const productsSection = pgettext("dropdown", "Products");
        const substancesSection = pgettext("dropdown", "Active substances");

        return (
            <div className={`dropdown dropdown-search ${this.state.query ? "open" : ""}`}>
                <div className="input-icon input-icon-left">
                    <input
                        type="text"
                        className="form-control"
                        id="title_icon_focus"
                        autoComplete="off"
                        name="q"
                        placeholder={gettext("Search products...")}
                        onChange={this.onChange}
                        onFocus={setFocus}
                        onBlur={unsetFocus}
                        onMouseOver={setHover}
                        onMouseOut={unsetHover}
                        value={this.state.query}
                    />
                    <i
                        className={`icon icon-form icon--${this.state.query ? 'close icon-medium' : 'search'}`}
                        onClick={() => this.setState(
                            {query: ''},
                            () => this.initialQuery.length && document.forms.main_search.submit(),
                        )}
                    />
                </div>

                <ul
                    className={`dropdown-menu list-unstyled ${showDropdown ? '' : 'hidden'}`}
                    onMouseOver={setHover}
                    onMouseOut={unsetHover}
                >
                    {spelling.length ? <li><strong>{gettext("Did you mean?")}</strong></li> : null}
                    {spelling}
                    {spelling.length && (products.length || facets.length) ? <li className="divider" /> : null}
                    {products.length ? <li><strong>{productsSection}</strong></li> : null}
                    {products}
                    {products.length && facets.length ? <li className="divider" /> : null}
                    {facets.length ? <li><strong>{substancesSection}</strong></li> : null}
                    {facets}
                </ul>
            </div>
        );
    }
}


export default Search;



// WEBPACK FOOTER //
// ./src/components/Search.js